module.exports = "https://cdn01.riselinkedu.com/assets/lottie/img_4.e8576c4e.png";